import { IAdditionalPassenger, ICustomerContact, IUserResponse, PassengerSelectReqType, RememberMeReqType, SyncCustomerPassenger, UpdateCustomerContactForm, UpdatePassengerReqType } from "../../../../Orchestrator/Types/Index";

export class PassengerDetailsContext {
    public updatePassengerReqType!: UpdatePassengerReqType
    public updateCustomerContactForm!: UpdateCustomerContactForm
    public syncCustomerPassenger!: SyncCustomerPassenger
    public passengerSelectReqType!: PassengerSelectReqType
    public rememberMeReqType!: RememberMeReqType

    public customerContactData!: IUserResponse | undefined
    public savedPassengers!: IAdditionalPassenger[] | undefined
    public updatedCustomerContact!: ICustomerContact | undefined | null
    
    constructor() {

    }
}